import { view, customization } from '@yola/ws-sdk';
import { SURFACES_ATTRIBUTE } from '../../blocks/constants/display-options';
import buttonPresetSectionIds from '../constants/button-preset-section-ids';
import { SURFACE_INDEX_ATTRIBUTE, SURFACE_CLASS_NAME } from '../../blocks/constants/common';
import getLargestBlock from '../../blocks/helpers/get-largest-block';
import getSafeColorScheme from './get-safe-color-scheme';
import { FALLBACK_COLOR_SCHEME } from '../constants/color-schemes';

const BUTTON_TYPE_TO_QUERY_SELECTOR = {
  [buttonPresetSectionIds.PRIMARY_BUTTON]:
    "ws-button[data-type='primary'], ws-header ws-button[slot='primary-button'], ws-contact-form-container ws-button[type='submit'], .ws-m-pricing-with-icon article ws-button, .ws-m-table-with-buttons table td ws-button, .ws-m-pricing-card-with-media figure ws-button",
  [buttonPresetSectionIds.SECONDARY_BUTTON]:
    "ws-button[data-type='secondary'], ws-header ws-button[slot='secondary-button']",
};

const COLUMN_WITH_SURFACE_SELECTOR = 'ws-column[surface]';

const getTargetSurfaceForButtonPreset = (buttonType, scrollPosition, viewportHeight) => {
  const buttonSelector = BUTTON_TYPE_TO_QUERY_SELECTOR[buttonType];
  const pageBlocks = view.accessors.getPageBlocks();
  const largestBlock = getLargestBlock(pageBlocks, {
    viewportHeight,
    scrollPosition,
  });

  const targetButton = largestBlock.querySelector(buttonSelector);
  if (!targetButton) {
    return FALLBACK_COLOR_SCHEME;
  }

  const colorPalette = customization.accessors.getCurrentColorPalette();
  const columnWithSurface = targetButton.closest(COLUMN_WITH_SURFACE_SELECTOR);
  if (columnWithSurface) {
    const targetSurface = columnWithSurface.getAttribute('surface');
    return getSafeColorScheme(targetSurface, colorPalette);
  }

  const surfacesAttribute = largestBlock.getAttribute(SURFACES_ATTRIBUTE);
  if (!surfacesAttribute) {
    return FALLBACK_COLOR_SCHEME;
  }

  const surfaceElement = targetButton.closest(`.${SURFACE_CLASS_NAME}`);
  const surfaceIndex = surfaceElement.getAttribute(SURFACE_INDEX_ATTRIBUTE);
  const surfaces = surfacesAttribute.split(' ');
  const targetSurface = surfaces[surfaceIndex];

  return getSafeColorScheme(targetSurface, colorPalette) || FALLBACK_COLOR_SCHEME;
};

export default getTargetSurfaceForButtonPreset;
